import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {IconComponent} from '../../common/icon-picker/icon-picker.component';
import {PageService} from '../../../common/services';
import {Page} from '../../../common/services';

@Component({
  selector: 'app-page-preview',
  templateUrl: './page-preview.component.html',
  styleUrls: ['./page-preview.component.scss']
})
export class PagePreviewComponent implements OnInit {
  page: Page;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<IconComponent>,
              private pageService: PageService) {
    if (data) {
      this.pageService.get(data.id).subscribe((page) => {
        this.page = page;
      });
    }
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close(null);
  }
}
